/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Nav_ExamplesInputs */

const en_road_dude_nav_examples = /** @type {(inputs: Road_Dude_Nav_ExamplesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video examples`)
};

const zh_road_dude_nav_examples = /** @type {(inputs: Road_Dude_Nav_ExamplesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频案例`)
};

/**
* | output |
* | --- |
* | "Video examples" |
*
* @param {Road_Dude_Nav_ExamplesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_nav_examples = /** @type {((inputs?: Road_Dude_Nav_ExamplesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Nav_ExamplesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_nav_examples(inputs)
	return zh_road_dude_nav_examples(inputs)
});
export { road_dude_nav_examples as "road_dude.nav.examples" }